'use client';

import type { ConvertedThemeSwipeItem } from '@weberus/shared-types/src/display/widgets/theme-swipe';
import type { FC } from 'react';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { useEffect } from 'react';
import { Thumbnail } from '@yanolja-rnd/nol-design-system';
import { useInView } from 'react-intersection-observer';
import { clientLogStandardized } from '@weberus/client-tracker';

interface ThemeSwipeItemProps extends ConvertedThemeSwipeItem {
  pageNameLog: HomeLogPageNameValue;
  widgetLogMeta?: object;
}
const ThemeSwipeItem: FC<ThemeSwipeItemProps> = ({ title, imgUrl, linkUrl, pageNameLog, widgetLogMeta, logMeta }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      clientLogStandardized('impression', pageNameLog, { ...widgetLogMeta, ...logMeta });
    }
  }, [inView]);

  return (
    <a
      ref={ref}
      href={linkUrl}
      className="flex w-72 flex-col gap-8 pc:w-100 pc:gap-12"
      onClick={() => clientLogStandardized('click', pageNameLog, { ...widgetLogMeta, ...logMeta })}>
      <Thumbnail alt="" ratio="3_4" shape="capsule" image={imgUrl} />

      <div className="text-center typography-body-13-regular-line-clamp-1 pc:typography-subtitle-18-regular-line-clamp-1">
        {title}
      </div>
    </a>
  );
};

export default ThemeSwipeItem;
